import o from"./can-use-dom.js";var a=o&&/(iPhone|iPod|iPad)/i.test(navigator.platform);export{a as default};
//# sourceMappingURL=is-ios.js.map
